import helpers from "../common/lib/helpers";
import i18next from "../common/i18n";

const hdlIdentifierValidation = (
    identifiers = {},
    altAsset = {},
    rules = {},
    invalidIdentifiers = []
) => {
    const next = {};
    let hasValidationFailed = false;

    // validate VIN against list of InvalidVins
    const found = invalidIdentifiers.find(
        (item) =>
            item.name === altAsset.identifier1 && item.typeId === altAsset.type
    );

    if (found) {
        next["identifier1"] = i18next.t("errors.invalidIdentifier");
        return [true, next];
    }

    Object.keys(identifiers).forEach((name) => {
        const text = altAsset[name];
        next[name] = null;

        if (rules[name]) {
            const { maxLength, minLength } = rules[name];
            const regex = helpers.regex.parseString(rules[name].regex);
            if (regex && text && !regex.test(text)) {
                const invalidChar = helpers.regex
                    .getInvalidCharacters(regex, text)
                    .join(",");
                next[name] = i18next.t("errors.invalidCharacters", {
                    invalidChar,
                });
            } else if (maxLength && text && text.length > maxLength) {
                next[name] = i18next.t("errors.maxLength", { maxLength });
            } else if (minLength && text && text.length < minLength) {
                next[name] = i18next.t("errors.minLength", { minLength });
            }
        }

        if (next[name] === null) delete next[name];
        else hasValidationFailed = true;
    });

    return [hasValidationFailed, next];
};

export default hdlIdentifierValidation;
